module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b6ca5259f1271d510f081867e746847.png";